import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06210190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex mt-12 mx-12 mb-3sm items-center flex-wrap" }
const _hoisted_3 = { class: "relative rounded-xl shadow-sm w-full lg:w-338 md:mr-4" }
const _hoisted_4 = { class: "input-icon-wrapper z-40" }
const _hoisted_5 = {
  key: 0,
  class: "h-42 w-full mb-4 md:mb-0 rounded-xl bg-gray-200 animate-pulse2"
}
const _hoisted_6 = { class: "relative z-40 mb-4 md:mb-0" }
const _hoisted_7 = { class: "block truncate" }
const _hoisted_8 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_9 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_10 = { class: "flex items-center 2xl:mt-0 w-full md:w-auto" }
const _hoisted_11 = { class: "relative rounded-xl shadow-sm w-full md:w-[338px]" }
const _hoisted_12 = ["max"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block mx-3 md:mx-5" }, "-", -1))
const _hoisted_14 = { class: "relative rounded-xl shadow-sm w-full md:w-[338px] md:mr-4" }
const _hoisted_15 = ["min", "max"]
const _hoisted_16 = { class: "mx-9" }
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-x-7 gap-y-5 justify-items-center transition-all" }
const _hoisted_18 = { class: "mt-8 lg:flex items-center justify-between" }

import { defineComponent, onMounted, ref, inject, computed, watch } from 'vue';
import { SearchIcon } from '@heroicons/vue/solid';
import StatsCard from '@/components/shared/StatsCard.vue';
import ChartStacked from '@/components/ChartStacked.vue';
import SystemOverview from '@/components/SystemOverview.vue';
import OccupancyOverview from '@/components/OccupancyOverview.vue';
import 'chartjs-plugin-style';
import VehicleImg from '@/assets/img/vehicle.svg';
import OccupiedIcon from '@/assets/img/occupied1.svg';
import TimeImg from '@/assets/img/time.svg';
import IceImg from '@/assets/img/ice.svg';
import BayHog from '@/assets/img/hog.svg';
import { getLocation, getAnalytics } from '@/services/api.service';
import { AxiosStatic } from 'axios';
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue';
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid';
import { Analytics, Location } from '@/types/interface';
import {
  generate24HTime,
  secondsToHmSs,
  getDateRange,
  convertToYyMmDd,
} from '@/utils/dateTimeFormat';
import { format } from 'date-fns';
import Spinner from '@/components/shared/Spinner.vue';
import useLoading from '@/use/useLoading';

type AnalyticsData = {
  [key: string]: number;
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
const $axios = inject('$axios') as AxiosStatic;
const location = ref<Location[]>([]);
const analytics = ref<Analytics[]>([]);
const vehicleChargeData = ref(0);
const sameDuration = ref<string[]>(['']);
const dateSearchRange = ref();
const currentDate = ref(format(new Date(), 'yyyy-MM-dd'));
const dateRange = ref({
  startDate: '',
  endDate: '',
});
// Default start date 7 days from current date
const startDate = ref(
  new Date(new Date().setDate(new Date().getDate() - 7))
    .toISOString()
    .substring(0, 10)
);
const endDate = ref(format(new Date(), 'yyyy-MM-dd'));

const selectedLocation = ref({
  name: '',
  id: '',
});
const selectedLocationProp = ref({
  name: '',
  id: '',
});

const { isLoading } = useLoading(false);
const analyticsLoading = ref(true);
const totalProducts = ref(0);
const visibleItemsPerPageCount = ref(10);
const currentPage = ref(0);
const currentPageEnd = ref(5);
const currentPageStart = ref(1);
const pageCount = ref(0);
const analyticsPaginated = ref<Analytics[]>([]);

const handlePaginate = (e: number) => {
  const trimStart = (e - 1) * visibleItemsPerPageCount.value;
  const trimEnd = trimStart + visibleItemsPerPageCount.value;
  analyticsPaginated.value = analytics.value.slice(trimStart, trimEnd);
  currentPage.value = e;
  currentPageStart.value = trimStart + 1;
  if (trimEnd > totalProducts.value) {
    return (currentPageEnd.value = totalProducts.value);
  }
  currentPageEnd.value = trimEnd;
};

const handleLocation = async () => {
  isLoading.value = true;
  try {
    const { data } = await getLocation($axios);
    location.value = data;
    selectedLocation.value = location.value[0];
    dateRange.value.startDate = startDate.value;
    dateRange.value.endDate = endDate.value;
  } catch (e: any) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
const mountOnce = ref(false);

watch(
  () => [selectedLocation.value, startDate.value, endDate.value],
  async () => {
    if (mountOnce.value) {
      await handleAnalytics(
        selectedLocation.value.id,
        startDate.value,
        endDate.value
      );
    }
    if (startDate.value !== endDate.value && mountOnce.value) {
      initAnalytics();
    }
  }
);

async function handleAnalytics(
  locationID: string,
  startDate: string,
  endDate: string
) {
  try {
    const { data } = await getAnalytics($axios, locationID, startDate, endDate);
    analytics.value = data;
    totalProducts.value = data.length;

    // Set pagination
    pageCount.value = Math.ceil(
      totalProducts.value / visibleItemsPerPageCount.value
    );
    // Display first nth analyrics data
    analyticsPaginated.value = analytics.value.slice(
      0,
      visibleItemsPerPageCount.value
    );

    // analytics.value = analytics.value.map((a) => {
    //   a.bayHoggingIncident = false;
    //   a.icingIncident = false;
    //   a.charging = true;
    //   return a;
    // });
    const charged = analytics.value.filter((c) => c.charging);
    vehicleChargeData.value = charged.length;
    selectedLocationProp.value = selectedLocation.value;
    if (startDate === endDate) {
      sameDuration.value = generate24HTime();
      initAnalyticsSameDay();
    }
  } catch (e: any) {
    console.error(e);
  } finally {
    analyticsLoading.value = false;
  }
}

const vehicleChargingSamedayResult = ref();
const icingIncidentSamedayResult = ref();
const bayHoggingSamedayResult = ref();
const averageChargeSamedayResult = ref();
const vehicleOccupiedSamedayResult = ref();

function initAnalyticsSameDay() {
  // const chargedVehicle = analytics.value.filter(
  //   (item) => !item.icingIncident && !item.bayHoggingIncident
  // );
  const charging: Analytics[] = [];
  const occupied: Analytics[] = [];
  const bayhogging: Analytics[] = [];
  const icingIncident: Analytics[] = [];

  analytics.value.forEach((item: Analytics) => {
    if (!item.occupiedEnd) {
      if (item.charging) {
        charging.push(item);
      } else {
        occupied.push(item);
      }
    } else {
      if (item.charging) {
        charging.push(item);
      }
      if (item.bayHoggingIncident) {
        bayhogging.push(item);
      }
      if (item.icingIncident) {
        icingIncident.push(item);
      }
      if (!item.bayHoggingIncident && !item.icingIncident && !item.charging) {
        occupied.push(item);
      }
    }
  });

  // Vehicle charging same day
  const occupiedStart = charging.map((item) => {
    let hours = new Date(item.occupiedStart).getHours();
    // Truncate :00 from array of 24 hours time
    let result = sameDuration.value
      .map((val) => Number(val.substring(0, val.length - 3)))
      .indexOf(hours);
    return result;
  });

  vehicleChargingSamedayResult.value = occupiedStart;

  // Vehicle occupied same day
  const occupiedIncidentByDate = occupied.map((item) => {
    let hours = new Date(item.occupiedStart).getHours();
    // Truncate :00 from array of 24 hours time
    return sameDuration.value
      .map((val) => Number(val.substring(0, val.length - 3)))
      .indexOf(hours);
  });

  console.log(occupiedIncidentByDate);

  vehicleOccupiedSamedayResult.value = occupiedIncidentByDate;

  //  Icing incident same day
  // const icing = analytics.value.filter((item) => {
  //   return item.icingIncident == true;
  // });

  const iceIncidentByDate = icingIncident.map((item) => {
    let hours = new Date(item.occupiedStart).getHours();
    // Truncate :00 from array of 24 hours time
    let result = sameDuration.value
      .map((val) => Number(val.substring(0, val.length - 3)))
      .indexOf(hours);
    return result;
  });

  icingIncidentSamedayResult.value = iceIncidentByDate;

  //  Bay hogging same day
  // const bayHog = analytics.value.filter(
  //   (item) => item.bayHoggingIncident && !item.icingIncident
  // );

  const bayHogByDate = bayhogging.map((item) => {
    let hours = new Date(item.occupiedStart).getHours();
    // Truncate :00 from array of 24 hours time
    let result = sameDuration.value
      .map((val) => Number(val.substring(0, val.length - 3)))
      .indexOf(hours);
    return result;
  });

  bayHoggingSamedayResult.value = bayHogByDate;

  //  Avg Charging  same day
  const avgCharge = analytics.value
    .filter((item) => !item.bayHoggingIncident && !item.icingIncident)
    .map(({ duration, occupiedStart }) => {
      // Math.round(duration / 60),
      return {
        duration: duration ? Math.round(duration) / 60 : 0,
        occupiedStart: new Date(occupiedStart).getHours(),
      };
    });

  averageChargeSamedayResult.value = avgCharge;
}

const avgTimeCharged = computed(() => {
  let data;
  data =
    analytics.value
      .filter((avg) => !avg.icingIncident && !avg.bayHoggingIncident)
      .map((item) => {
        if (item.duration) {
          return item.duration;
        }
        return 0;
      })
      .reduce((a, b) => a + b, 0) /
    analytics.value.filter(
      (avg) => !avg.icingIncident && !avg.bayHoggingIncident
    ).length;

  return secondsToHmSs(data);

  //     .map((item: any) => {
  //       if (item.duration) {
  //         return item.duration;
  //       }
  //       return 0;
  //     })
  //     .reduce((a: number, b: number) => a + b, 0) / analytics.value.length;
  // data = secondsToHmSs(data);
  // return data;
});

const icingIncident = computed(() => {
  return analytics.value
    .filter((item) => {
      return item.icingIncident;
    })
    .length.toLocaleString();
});

const occupiedIncident = computed(() => {
  return analytics.value
    .filter((item) => {
      return (
        !item.icingIncident && !item.bayHoggingIncident && !item.icingIncident
      );
    })
    .length.toLocaleString();
});

const bayHogging = computed(() => {
  const bayHoggingIncident = analytics.value.filter(
    (station) => station.bayHoggingIncident && !station.icingIncident
  );
  return bayHoggingIncident.length ? bayHoggingIncident.length : 0;
});

const handleSearch = () => {
  handleAnalytics(selectedLocation.value.id, startDate.value, endDate.value);
};

const chargedVehicles = ref<AnalyticsData>({});
const icingVehicles = ref<AnalyticsData>({});
const bayhogVehicles = ref<AnalyticsData>({});
const averageChargeTime = ref<AnalyticsData>({});
const occupiedVehicles = ref<AnalyticsData>({});

function initAnalytics() {
  // Generate date range
  const dates = getDateRange(startDate.value, endDate.value);
  const range = dates.map((item: any) => convertToYyMmDd(item));
  dateSearchRange.value = range;

  // Get each day of the month generated
  // const vehicleChargedResult = analytics.value.filter((item: Analytics) => {
  //   return !item.occupiedEnd && item.charging;
  // });

  const charging: Analytics[] = [];
  const occupied: Analytics[] = [];
  const bayhogging: Analytics[] = [];
  const icingIncident: Analytics[] = [];

  analytics.value.forEach((item: Analytics) => {
    if (!item.occupiedEnd) {
      if (item.charging) {
        charging.push(item);
      } else {
        occupied.push(item);
      }
    } else {
      if (item.charging) {
        charging.push(item);
      }
      if (item.bayHoggingIncident) {
        bayhogging.push(item);
      }
      if (item.icingIncident) {
        icingIncident.push(item);
      }
      if (!item.bayHoggingIncident && !item.icingIncident && !item.charging) {
        occupied.push(item);
      }
    }
  });

  const occupiedVehicleCharged = charging.map((item) => {
    return new Date(item.occupiedStart).getDate();
  });

  //  Group icing vehicle by the date range generated
  const groupIcingVehicleChargedResult: AnalyticsData =
    occupiedVehicleCharged.reduce(
      (cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt),
      {}
    );
  chargedVehicles.value = groupIcingVehicleChargedResult;

  // const resultDate = analytics.value.map((item: Analytics) => {
  //   let date = new Date(item.occupiedStart).getDate();
  //   return date;
  // });
  // Charged vehicles data
  //  Group charged vehicle by the date range generated
  // let groupChargedVehiclesByDate: AnalyticsData = resultDate.reduce(
  //   (cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt),
  //   {}
  // );
  // chargedVehicles.value = groupChargedVehiclesByDate;

  // Iceing vehicle data
  // const icingResult = analytics.value.filter((item: Analytics) => {
  //   return item.icingIncident === true;
  // });

  let occupiedIcing = icingIncident.map((item) => {
    return new Date(item.occupiedStart).getDate();
  });

  //  Group icing vehicle by the date range generated
  let groupIcingVehiclesByDate: AnalyticsData = occupiedIcing.reduce(
    (cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt),
    {}
  );
  icingVehicles.value = groupIcingVehiclesByDate;

  let occupiedRes = occupied.map((item) => {
    return new Date(item.occupiedStart).getDate();
  });

  //  Group icing vehicle by the date range generated
  let groupOccupiedVehiclesByDate: AnalyticsData = occupiedRes.reduce(
    (cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt),
    {}
  );
  occupiedVehicles.value = groupOccupiedVehiclesByDate;

  // const bayHogRsult = analytics.value.filter((item: Analytics) => {
  //   return item.bayHoggingIncident && !item.icingIncident;
  // });

  const occupiedBayHog = bayhogging.map((item) => {
    return new Date(item.occupiedStart).getDate();
  });
  //  Group bay hogging vehicle by the date range generated
  const groupBayHogVehiclesByDate: AnalyticsData = occupiedBayHog.reduce(
    (cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt),
    {}
  );
  bayhogVehicles.value = groupBayHogVehiclesByDate;

  // average time charging data
  const avgTimeDate = analytics.value
    .filter((avg) => !avg.icingIncident && !avg.bayHoggingIncident)
    .map((item: Analytics) => {
      let date = new Date(item.occupiedStart).getDate();
      return {
        date,
        duration: item.duration ? item.duration / 60 : 0,
      };
    });

  let groupAverageChargeByDate: AnalyticsData = avgTimeDate.reduce(
    (cnt, cur) => (
      (cnt[cur.date] = cnt[cur.date] + (cur.duration || 0) || 0), cnt
    ),
    {}
  );
  averageChargeTime.value = groupAverageChargeByDate;
}

onMounted(async () => {
  await handleLocation();
  await handleAnalytics(
    selectedLocation.value.id,
    startDate.value,
    endDate.value
  );
  mountOnce.value = true;
  initAnalytics();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(SearchIcon), {
            class: "h-7 w-7 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : (_openBlock(), _createBlock(_unref(Listbox), {
              key: 1,
              modelValue: selectedLocation.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLocation).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(ListboxButton), { class: "relative w-full py-2 pl-16 pr-10 h-42 text-left bg-white input-main" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(selectedLocation.value.name), 1),
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_unref(SelectorIcon), {
                          class: "w-5 h-5 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ListboxOptions), { class: "absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location.value, (person) => {
                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                              key: person.name,
                              value: person,
                              as: "template"
                            }, {
                              default: _withCtx(({ active, selected }) => [
                                _createElementVNode("li", {
                                  class: _normalizeClass([
                      active ? 'text-amber-900 bg-amber-100' : 'text-gray-900',
                      'cursor-default select-none relative py-2 pl-10 pr-4',
                    ])
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["text-xl", [
                        selected ? 'font-medium' : 'font-normal',
                        'block truncate',
                      ]])
                                  }, _toDisplayString(person.name), 3),
                                  selected
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                        _createVNode(_unref(CheckIcon), {
                                          class: "w-5 h-5",
                                          "aria-hidden": "true"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            name: "startDate",
            id: "startDate",
            max: endDate.value,
            class: "input-main block w-full h-42 md:px-10 border-gray-300",
            placeholder: "From",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event))
          }, null, 8, _hoisted_12), [
            [_vModelText, startDate.value]
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            name: "endDate",
            id: "endDate",
            class: "input-main block w-full h-42 md:px-10 border-gray-300",
            placeholder: "To",
            min: startDate.value,
            max: currentDate.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event))
          }, null, 8, _hoisted_15), [
            [_vModelText, endDate.value]
          ])
        ])
      ]),
      _createElementVNode("div", { class: "md:mt-0 mt-4 2xl:mt-0 w-full md:w-28 h-42 flex items-center" }, [
        _createElementVNode("button", {
          type: "submit",
          onClick: handleSearch,
          class: "btn-main flex items-center",
          style: {"height":"38px"}
        }, " Search ")
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(StatsCard, {
          title: "Vehicles Charged",
          img: _unref(VehicleImg),
          "stats-one": vehicleChargeData.value,
          "stats-two": "56%",
          success: true,
          id: "vehicle",
          "chart-data": chargedVehicles.value,
          "date-search-range": dateSearchRange.value,
          "same-duration": sameDuration.value,
          "vehicle-charging-sameday-result": vehicleChargingSamedayResult.value
        }, null, 8, ["img", "stats-one", "chart-data", "date-search-range", "same-duration", "vehicle-charging-sameday-result"]),
        _createVNode(StatsCard, {
          title: "Occupied Bay",
          img: _unref(OccupiedIcon),
          "stats-one": _unref(occupiedIncident),
          "stats-two": "56%",
          success: true,
          id: "occupied",
          "chart-data": occupiedVehicles.value,
          "date-search-range": dateSearchRange.value,
          "same-duration": sameDuration.value,
          vehicleOccupiedSamedayResult: vehicleOccupiedSamedayResult.value
        }, null, 8, ["img", "stats-one", "chart-data", "date-search-range", "same-duration", "vehicleOccupiedSamedayResult"]),
        _createVNode(StatsCard, {
          title: "Avg. Time Charging",
          img: _unref(TimeImg),
          "stats-one": _unref(avgTimeCharged),
          "stats-two": "15%",
          success: true,
          id: "time",
          "chart-data": averageChargeTime.value,
          "date-search-range": dateSearchRange.value,
          "same-duration": sameDuration.value,
          "average-charge-sameday-result": averageChargeSamedayResult.value
        }, null, 8, ["img", "stats-one", "chart-data", "date-search-range", "same-duration", "average-charge-sameday-result"]),
        _createVNode(StatsCard, {
          title: "Iceing Incidents",
          img: _unref(IceImg),
          "stats-one": _unref(icingIncident),
          "stats-two": "32%",
          success: false,
          id: "ice",
          "chart-data": icingVehicles.value,
          "date-search-range": dateSearchRange.value,
          "same-duration": sameDuration.value,
          "icing-incident-sameday-result": icingIncidentSamedayResult.value
        }, null, 8, ["img", "stats-one", "chart-data", "date-search-range", "same-duration", "icing-incident-sameday-result"]),
        _createVNode(StatsCard, {
          title: "Bay Hogging Incidents",
          img: _unref(BayHog),
          "stats-one": _unref(bayHogging),
          "stats-two": "32%",
          success: false,
          id: "hog",
          "chart-data": bayhogVehicles.value,
          "date-search-range": dateSearchRange.value,
          "same-duration": sameDuration.value,
          "icing-incident-sameday-result": bayHoggingSamedayResult.value
        }, null, 8, ["img", "stats-one", "chart-data", "date-search-range", "same-duration", "icing-incident-sameday-result"])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createVNode(ChartStacked, {
          "charged-vehicles": chargedVehicles.value,
          vehicleChargeData: vehicleChargeData.value,
          "icing-vehicles": icingVehicles.value,
          "occupied-vehicles": occupiedVehicles.value,
          "bay-hogging": bayhogVehicles.value,
          "same-duration": sameDuration.value,
          analytics: analytics.value,
          "is-loading": analyticsLoading.value,
          "date-range": dateRange.value,
          "date-search-range": dateSearchRange.value,
          "vehicle-charging-sameday-result": vehicleChargingSamedayResult.value,
          "vehicle-occupied-sameday-result": vehicleOccupiedSamedayResult.value,
          "icing-incident-sameday-result": icingIncidentSamedayResult.value,
          bayHoggingSamedayResult: bayHoggingSamedayResult.value,
          vehicleOccupiedSamedayResult: vehicleOccupiedSamedayResult.value
        }, null, 8, ["charged-vehicles", "vehicleChargeData", "icing-vehicles", "occupied-vehicles", "bay-hogging", "same-duration", "analytics", "is-loading", "date-range", "date-search-range", "vehicle-charging-sameday-result", "vehicle-occupied-sameday-result", "icing-incident-sameday-result", "bayHoggingSamedayResult", "vehicleOccupiedSamedayResult"]),
        _createVNode(OccupancyOverview, {
          "is-loading": analyticsLoading.value,
          "date-search-range": dateSearchRange.value,
          sameDuration: sameDuration.value,
          analytics: analytics.value,
          vehicleChargeData: vehicleChargeData.value,
          "icing-incident": _unref(icingIncident),
          selectedLocation: selectedLocation.value
        }, null, 8, ["is-loading", "date-search-range", "sameDuration", "analytics", "vehicleChargeData", "icing-incident", "selectedLocation"])
      ]),
      _createVNode(SystemOverview, {
        analytics: analyticsPaginated.value,
        "selected-location": selectedLocationProp.value,
        totalProducts: totalProducts.value,
        visibleItemsPerPageCount: visibleItemsPerPageCount.value,
        pageCount: pageCount.value,
        "is-loading": analyticsLoading.value,
        currentPage: currentPage.value,
        currentPageEnd: currentPageEnd.value,
        currentPageStart: currentPageStart.value,
        onHandlePaginate: handlePaginate
      }, null, 8, ["analytics", "selected-location", "totalProducts", "visibleItemsPerPageCount", "pageCount", "is-loading", "currentPage", "currentPageEnd", "currentPageStart"])
    ])
  ]))
}
}

})